export default "__VITE_PUBLIC_ASSET__a812b4ed__"